import React, { useEffect } from 'react';
import Loader from '../layout/Loader';
import { useGetAdminUsersQuery } from '../../redux/api/userApi';
import MetaData from '../layout/MetaData';
import AdminLayout from '../layout/AdminLayout';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const ListUsers = () => {
  const { data, isLoading, error } = useGetAdminUsersQuery();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
  }, [error]);

  if (isLoading) return <Loader />;

  return (
    <AdminLayout>
      <MetaData title="All Users (Admin)" />
      <div className="container py-4">
        <h2 className="mb-4">{data?.users?.length || 0} Users</h2>

        <div className="card">
          <div className="table-responsive">
            <table className="table mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data?.users?.map((user) => (
                  <tr key={user?._id}>
                    <td>{user?.name}</td>
                    <td>{user?.email}</td>
                    <td>
                      <span className={`badge ${user?.role === 'driver' ? 'badge-primary' : 'badge-success'}`}>
                        {user?.role}
                      </span>
                    </td>
                    <td>
                      <Link to={`/admin/users/${user?._id}`} className="btn btn-sm btn-outline-primary">
                        <i className="fa fa-eye" />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default ListUsers;